import { formatISO } from "date-fns";
import {
  ElectionBallot,
  ElectionBallotMeta,
  ElectionMapWinners,
  ElectionNews,
  ElectionObservation,
  ElectionResults,
  ElectionScopeResolved,
  ElectionTurnout,
  ElectionResultsPartyCandidates,
} from "../types/Election";
import { APIMockHandler, mockFetch } from "./api";
import { makeElectionApi } from "./electionApi";

export const mockNationalElectionScope: ElectionScopeResolved = { type: "national" };
export const mockCountyElectionScope: ElectionScopeResolved = { type: "county", countyId: 1, countyName: "Prahova" };
export const mockLocalityElectionScope: ElectionScopeResolved = {
  type: "locality",
  countyId: 1,
  localityId: 1,
  countyName: "Prahova",
  localityName: "Ploiești",
};
export const mockDiasporaElectionScope: ElectionScopeResolved = { type: "diaspora" };
export const mockDiasporaCountryElectionScope: ElectionScopeResolved = {
  type: "diaspora_country",
  countryId: 1,
  countryName: "Spania",
};

export const mockPresidentialElectionMeta: ElectionBallotMeta = {
  type: "president",
  date: "2019-11-24",
  title: "Alegeri prezidențiale",
  ballot: "Turul 2",
  ballotId: 1,
  electionId: 1,
  live: true,
  stage: "final",
};

export const mockLocalCouncilElectionMeta: ElectionBallotMeta = {
  type: "local_council",
  date: "2016-06-05",
  title: "Alegeri locale",
  ballot: "Consiliul Local",
  ballotId: 2,
  electionId: 2,
  live: true,
  stage: "part",
};

export const mockMayorElectionMeta: ElectionBallotMeta = {
  type: "mayor",
  date: "2016-06-05",
  title: "Alegeri locale",
  ballot: "Consiliul Local",
  ballotId: 4,
  electionId: 4,
};

export const mockCountyCouncilElectionMeta: ElectionBallotMeta = {
  type: "county_council_president",
  date: "2016-06-05",
  title: "Alegeri Locale",
  ballot: "Consiliul judetean",
  ballotId: 3,
  electionId: 3,
};

export const mockPresidentialElectionTurnout: ElectionTurnout = {
  eligibleVoters: 18217411,
  totalVotes: 9086696,
  breakdown: [
    {
      type: "national",
      total: 18217411,
      categories: [
        {
          type: "permanent_lists",
          votes: 7839020,
        },
        {
          type: "supplementary_lists",
          votes: 1167827,
        },
        {
          type: "mobile_ballot_box",
          votes: 79849,
        },
      ],
    },
    {
      type: "diaspora",
      categories: [
        {
          type: "supplementary_lists",
          votes: 926574,
        },
        {
          type: "vote_by_mail",
          votes: 17503,
        },
      ],
    },
  ],
};

export const mockObservation: ElectionObservation = {
  coveredPollingPlaces: 431,
  coveredCounties: 34,
  observerCount: 823,
  messageCount: 500,
  issueCount: 231,
};

export const mockResults: ElectionResults = {
  totalVotes: 8893672,
  countedVotes: 3893672,
  validVotes: 8893572,
  nullVotes: 100,
  eligibleVoters: 15119242,
  totalSeats: 136,
  candidates: [
    {
      name: "PARTIDUL SOCIAL DEMOCRAT",
      shortName: "PSD",
      partyColor: "#DC2C23",
      votes: 2890344,
      seats: 67,
      seatsGained: 8,
      partyLogo:
        // eslint-disable-next-line max-len
        "data:image/png;base64,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",
    },
    {
      name: "PARTIDUL NAȚIONAL LIBERAL",
      shortName: "PNL",
      partyColor: "#0068AC",
      votes: 2529986,
      seats: 30,
      seatsGained: -20,
      partyLogo:
        // eslint-disable-next-line max-len
        "data:image/svg+xml;charset=utf-8;base64,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",
    },
    {
      name: "PARTIDUL ALIANȚA LIBERALILOR ȘI DEMOCRAȚILOR",
      shortName: "ALDE",
      partyColor: "#1292D0",
      votes: 521845,
      seats: 9,
    },
    {
      name: "UDMR",
      shortName: "UDMR",
      partyColor: "#339900",
      votes: 411823,
      seats: 9,
      partyLogo:
        // eslint-disable-next-line max-len
        "data:image/jpeg;base64,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",
    },
    {
      name: "Dummy 1",
      shortName: "DUM1",
      votes: 1063331,
    },
    {
      name: "Dummy 2",
      shortName: "DUM2",
      votes: 1063331,
    },
    {
      name: "Dummy 3",
      shortName: "DUM3",
      votes: 1063331,
    },
    {
      name: "Dummy 4",
      shortName: "DUM4",
      votes: 1063331,
    },
    {
      name: "Dummy 5",
      shortName: "DUM5",
      votes: 1063331,
    },
    {
      name: "Dummy 6",
      shortName: "DUM6",
      votes: 1063331,
    },
    {
      name: "Dummy 7",
      shortName: "DUM7",
      votes: 1063331,
    },
    {
      name: "Dummy 8",
      shortName: "DUM8",
      votes: 1063331,
    },
  ],
};

export const mockLocalCouncilResults = {
  countedVotes: 105683,
  eligibleVoters: 313454,
  totalVotes: 155683,
  validVotes: 150100,
  nullVotes: 5583,
  totalSeats: 0,
  candidates: [
    {
      name: "Partidul Național Liberal",
      partyColor: "#F8DD1B",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Na%C8%9Bional+Liberal.jpg",
      votes: 63835,
      seats: 422,
      totalSeats: 422,
    },
    {
      name: "Partidul Social Democrat",
      partyColor: "#FF0000",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Social+Democrat.jpg",
      votes: 5379,
      seats: 55,
      totalSeats: 55,
    },
    {
      name: "Alianța pentru Unirea Românilor",
      shortName: "A. pentru Unirea Românilor",
      partyColor: "#660066",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Alian%C8%9Ba+pentru+Unirea+Rom%C3%A2nilor.jpg",
      votes: 869,
      seats: 7,
      totalSeats: 7,
    },
    {
      name: "UNIUNEA DEMOCRATA MAGHIARA DIN ROMANIA",
      partyColor: "#007300",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Uniunea+Democrat%C4%83+a+Maghiarilor+din+Rom%C3%A2nia.jpg",
      votes: 825,
      seats: 11,
      totalSeats: 11,
    },
    {
      name: "Alianța Liberalilor și Democraților",
      shortName: "A. Liberalilor și Democraților",
      partyColor: "#B2B200",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Alian%C8%9Ba+Liberalilor+%C8%99i+Democra%C8%9Bilor.jpg",
      votes: 528,
      seats: 5,
      totalSeats: 5,
    },
    {
      name: "Partidul Miscarea Populară",
      partyColor: "#000099",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Miscarea+Popular%C4%83.jpg",
      votes: 161,
      seats: 6,
      totalSeats: 6,
    },
  ],
};

export const mockMayorResults = {
  countedVotes: 105683,
  eligibleVoters: 393847,
  totalVotes: 175789,
  validVotes: 170594,
  nullVotes: 5195,
  totalSeats: 0,
  candidates: [
    {
      name: "Partidul Național Liberal",
      partyColor: "#F8DD1B",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Na%C8%9Bional+Liberal.jpg",
      votes: 49,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "Partidul Social Democrat",
      partyColor: "#FF0000",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Social+Democrat.jpg",
      votes: 15,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "INDEPENDENT",
      shortName: "INDEPENDENT",
      partyColor: "#808080",
      votes: 8,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "UNIUNEA DEMOCRATA MAGHIARA DIN ROMANIA",
      partyColor: "#007300",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Uniunea+Democrat%C4%83+a+Maghiarilor+din+Rom%C3%A2nia.jpg",
      votes: 5,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "PARTIDUL PRO ROMÂNIA",
      partyColor: "#FF4C4C",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Pro+Romania.jpg",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
  ],
};

export const mockCountyCouncilResults = {
  eligibleVoters: 18466219,
  totalVotes: 8419716,
  validVotes: 7937514,
  nullVotes: 482202,
  totalSeats: 0,
  candidates: [
    {
      name: "Partidul Social Democrat",
      partyColor: "#FF0000",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Social+Democrat.jpg",
      votes: 16,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "Partidul Național Liberal",
      partyColor: "#F8DD1B",
      partyLogo: "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Partidul+Na%C8%9Bional+Liberal.jpg",
      votes: 15,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "UNIUNEA DEMOCRATA MAGHIARA DIN ROMANIA",
      partyColor: "#007300",
      partyLogo:
        "https://rezultatevot-media.s3.eu-central-1.amazonaws.com/v2/Logo__Uniunea+Democrat%C4%83+a+Maghiarilor+din+Rom%C3%A2nia.jpg",
      votes: 4,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "ALIANȚA ELECTORALĂ ALIANȚA PENTRU MODERNIZAREA NEAMȚULUI 2020",
      shortName: "A. ELECTORALĂ PENTRU MODERNIZAREA NEAMȚULUI 2020",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "ALIANȚA PNL USR PLUS",
      shortName: "A. PNL USR PLUS",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "ALIANȚA PENTRU BISTRIȚA-NĂSĂUD",
      shortName: "A. NĂSĂUD",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "INDEPENDENT",
      shortName: "INDEPENDENT",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "ALIANTA ELECTORALA PSD+ALDE DOLJ",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name: "ALIANȚA PSD-PRO BUZĂU",
      shortName: "A. PRO BUZĂU",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
    {
      name:
        "ALIANȚA PARTIDUL NAȚIONAL LIBERAL - UNIUNEA SALVAȚI ROMÂNIA - PARTIDUL LIBERTATE, UNITATE ȘI SOLIDARITATE (PNL-USR-PLUS)",
      shortName: "A.  UNIUNEA SALVAȚI ROMÂNIA - PARTIDUL LIBERTATE, UNITATE ȘI SOLIDARITATE (PNL-USR-PLUS)",
      partyColor: "#808080",
      votes: 1,
      seats: 0,
      totalSeats: 0,
    },
  ],
};

export const mockElectionList = [
  {
    date: "2019-11-10T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 1,
    ballotId: 1,
    round: 2,
  },
  {
    date: "2019-11-10T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 1,
    ballotId: 2,
    round: 1,
  },
  {
    date: "2019-05-26T00:00:00",
    title: "Alegeri EuroParlamentare",
    type: "european_parliament",
    ballot: "Alegeri EuroParlamentare",
    electionId: 2,
    ballotId: 3,
  },
  {
    date: "2019-05-26T00:00:00",
    title: "Referendum",
    subtitle: "Referendumul pe tema justiției",
    type: "referendum",
    ballot: "Referendum",
    electionId: 3,
    ballotId: 4,
  },
  {
    date: "2019-05-26T00:00:00",
    title: "Referendum",
    subtitle: "Referendumul pe tema justiției",
    type: "referendum",
    ballot: "Referendum",
    electionId: 3,
    ballotId: 5,
  },
  {
    date: "2016-12-11T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 4,
    ballotId: 6,
  },
  {
    date: "2016-12-11T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 4,
    ballotId: 7,
  },
  {
    date: "2016-06-05T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 5,
    ballotId: 8,
    round: 1,
  },
  {
    date: "2016-06-05T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 5,
    ballotId: 9,
    round: 2,
  },
  {
    date: "2016-06-05T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 5,
    ballotId: 10,
  },
  {
    date: "2016-06-05T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 5,
    ballotId: 11,
  },
  {
    date: "2014-11-02T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 6,
    ballotId: 12,
    round: 1,
  },
  {
    date: "2014-11-02T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 6,
    ballotId: 13,
    round: 2,
  },
  {
    date: "2014-05-25T00:00:00",
    title: "Alegeri EuroParlamentare",
    type: "european_parliament",
    ballot: "Alegeri EuroParlamentare",
    electionId: 7,
    ballotId: 14,
  },
  {
    date: "2014-05-25T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 8,
    ballotId: 15,
  },
  {
    date: "2014-05-25T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 8,
    ballotId: 16,
  },
  {
    date: "2012-12-09T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 9,
    ballotId: 17,
  },
  {
    date: "2012-12-09T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 9,
    ballotId: 18,
  },
  {
    date: "2012-07-29T00:00:00",
    title: "Referendum",
    subtitle: "Referendum pentru demiterea presedintelui Romaniei",
    type: "referendum",
    ballot: "Referendum",
    electionId: 10,
    ballotId: 19,
  },
  {
    date: "2012-06-10T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 11,
    ballotId: 20,
    round: 1,
  },
  {
    date: "2012-06-10T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 11,
    ballotId: 21,
    round: 2,
  },
  {
    date: "2012-06-10T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 11,
    ballotId: 22,
    round: 1,
  },
  {
    date: "2012-06-10T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 11,
    ballotId: 23,
    round: 2,
  },
  {
    date: "2012-06-10T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 11,
    ballotId: 24,
  },
  {
    date: "2009-11-22T00:00:00",
    title: "Referendum",
    subtitle: "Referendum pentru trecerea la parlament unicameral si reducerea numarului de parlamentari",
    type: "referendum",
    ballot: "Referendum",
    electionId: 12,
    ballotId: 25,
  },
  {
    date: "2009-11-22T00:00:00",
    title: "Referendum",
    subtitle: "Referendum pentru trecerea la parlament unicameral si reducerea numarului de parlamentari",
    type: "referendum",
    ballot: "Referendum",
    electionId: 12,
    ballotId: 26,
  },
  {
    date: "2009-11-22T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 13,
    ballotId: 27,
    round: 1,
  },
  {
    date: "2009-11-22T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 13,
    ballotId: 28,
    round: 2,
  },
  {
    date: "2009-06-07T00:00:00",
    title: "Alegeri EuroParlamentare",
    type: "european_parliament",
    ballot: "Alegeri EuroParlamentare",
    electionId: 14,
    ballotId: 29,
  },
  {
    date: "2008-11-30T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 15,
    ballotId: 30,
  },
  {
    date: "2008-11-30T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 15,
    ballotId: 31,
  },
  {
    date: "2008-06-01T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 16,
    ballotId: 32,
    round: 1,
  },
  {
    date: "2008-06-01T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 16,
    ballotId: 33,
    round: 2,
  },
  {
    date: "2008-06-01T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 16,
    ballotId: 34,
    round: 3,
  },
  {
    date: "2008-06-01T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 16,
    ballotId: 35,
  },
  {
    date: "2008-06-01T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 16,
    ballotId: 36,
  },
  {
    date: "2007-11-25T00:00:00",
    title: "Alegeri EuroParlamentare",
    type: "european_parliament",
    ballot: "Alegeri EuroParlamentare",
    electionId: 17,
    ballotId: 37,
  },
  {
    date: "2007-11-25T00:00:00",
    title: "Referendum",
    subtitle: "Referendum privind introducerea votului uninominal pentru alegerea membrilor Parlamentului Romaniei",
    type: "referendum",
    ballot: "Referendum",
    electionId: 18,
    ballotId: 38,
  },
  {
    date: "2007-05-19T00:00:00",
    title: "Referendum",
    subtitle: "Referendum pentru demiterea presedintelui Romaniei",
    type: "referendum",
    ballot: "Referendum",
    electionId: 19,
    ballotId: 39,
  },
  {
    date: "2004-11-28T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 20,
    ballotId: 40,
  },
  {
    date: "2004-11-28T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 20,
    ballotId: 41,
  },
  {
    date: "2004-11-28T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 21,
    ballotId: 42,
    round: 1,
  },
  {
    date: "2004-11-28T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 21,
    ballotId: 43,
    round: 2,
  },
  {
    date: "2004-06-06T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 22,
    ballotId: 44,
    round: 1,
  },
  {
    date: "2004-06-06T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 22,
    ballotId: 45,
    round: 2,
  },
  {
    date: "2004-06-06T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 22,
    ballotId: 46,
    round: 3,
  },
  {
    date: "2004-06-06T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 22,
    ballotId: 47,
  },
  {
    date: "2004-06-06T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 22,
    ballotId: 48,
  },
  {
    date: "2003-11-18T00:00:00",
    title: "Referendum",
    subtitle: "Referendumul constitutional din Romania",
    type: "referendum",
    ballot: "Referendum",
    electionId: 23,
    ballotId: 49,
  },
  {
    date: "2000-11-26T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 24,
    ballotId: 50,
  },
  {
    date: "2000-11-26T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 24,
    ballotId: 51,
  },
  {
    date: "2000-11-26T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 25,
    ballotId: 52,
    round: 1,
  },
  {
    date: "2000-11-26T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 25,
    ballotId: 53,
    round: 2,
  },
  {
    date: "2000-06-04T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 26,
    ballotId: 54,
    round: 1,
  },
  {
    date: "2000-06-04T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 26,
    ballotId: 55,
    round: 2,
  },
  {
    date: "2000-06-04T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 26,
    ballotId: 56,
  },
  {
    date: "2000-06-04T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 26,
    ballotId: 57,
  },
  {
    date: "1996-11-03T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 27,
    ballotId: 58,
  },
  {
    date: "1996-11-03T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 27,
    ballotId: 59,
  },
  {
    date: "1996-11-03T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 28,
    ballotId: 60,
    round: 1,
  },
  {
    date: "1996-11-03T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 28,
    ballotId: 61,
    round: 2,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 29,
    ballotId: 62,
    round: 1,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 29,
    ballotId: 63,
    round: 2,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "mayor",
    ballot: "Primar",
    electionId: 29,
    ballotId: 64,
    round: 3,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 29,
    ballotId: 65,
    round: 1,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "local_council",
    ballot: "Consiliul local",
    electionId: 29,
    ballotId: 66,
    round: 2,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 29,
    ballotId: 67,
    round: 1,
  },
  {
    date: "1996-06-02T00:00:00",
    title: "Alegeri Locale",
    type: "county_council",
    ballot: "Consiliul judetean",
    electionId: 29,
    ballotId: 68,
    round: 2,
  },
  {
    date: "1992-09-27T00:00:00",
    title: "Alegeri Parlamentare",
    type: "senate",
    ballot: "Senat",
    electionId: 30,
    ballotId: 69,
  },
  {
    date: "1992-09-27T00:00:00",
    title: "Alegeri Parlamentare",
    type: "house",
    ballot: "Camera Deputatilor",
    electionId: 30,
    ballotId: 70,
  },
  {
    date: "1992-09-27T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 1",
    electionId: 31,
    ballotId: 71,
    round: 1,
  },
  {
    date: "1992-09-27T00:00:00",
    title: "Alegeri Prezidențiale",
    type: "president",
    ballot: "Alegeri Prezidențiale - Turul 2",
    electionId: 31,
    ballotId: 72,
    round: 2,
  },
];

export const mockElectionNews: ElectionNews = {
  id: 1,
  timestamp: formatISO(Date.now() - 60 * 5),
  author: {
    name: "Dan Dincu",
    avatar: "https://tinyfac.es/data/avatars/03F55412-DE8A-4F83-AAA6-D67EE5CE48DA-200w.jpeg",
  },
  title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est imperdiet magnis sit urna curabitur enim.",
  pictures: ["https://picsum.photos/400/600", "https://picsum.photos/400/600"],
  body:
    "At malesuada ut aliquet tellus dignissim leo ut urna. Nascetur felis luctus parturient varius ipsum risus facilisis lacus neque. Dui sed nulla gravida tempus duis massa neque.\n\nNulla porttitor a nec vestibulum rutrum. Volutpat ultrices tellus, diam sollicitudin morbi pretium neque turpis.",
  embed:
    // eslint-disable-next-line quotes
    `<blockquote class="twitter-tweet" data-dnt="true"><p lang="ro" dir="ltr">📣 Acum e foarte simplu să afli la ce secție poți vota la alegerile locale din 27 septembrie. Tot ceea ce trebuie să faci este să intri pe 👉 <a href="https://t.co/J6X5d8vOaf">https://t.co/J6X5d8vOaf</a> și să introduci numele străzii unde locuiești, urmat de numele orașului. <a href="https://twitter.com/hashtag/votromania?src=hash&amp;ref_src=twsrc%5Etfw">#votromania</a> <a href="https://twitter.com/hashtag/code4romania?src=hash&amp;ref_src=twsrc%5Etfw">#code4romania</a> <a href="https://twitter.com/hashtag/civictech?src=hash&amp;ref_src=twsrc%5Etfw">#civictech</a> <a href="https://t.co/wVfm4qPQ7k">pic.twitter.com/wVfm4qPQ7k</a></p>&mdash; Code for Romania (@Code4Romania) <a href="https://twitter.com/Code4Romania/status/1306535717766672384?ref_src=twsrc%5Etfw">September 17, 2020</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`,
  link: "https://twitter.com/code4romania",
};

export const mockElectionMapWinners: ElectionMapWinners = [
  { id: 1, winner: { name: "PSD", partyColor: "red", votes: 800 }, validVotes: 1000 },
  { id: 16392, winner: { name: "PNL", partyColor: "yellow", votes: 700 }, validVotes: 1000 },
  { id: 13933, winner: { name: "USR", partyColor: "blue", votes: 600 }, validVotes: 1000 },
  { id: 4862, winner: { name: "UDMR", partyColor: "green", votes: 550 }, validVotes: 1000 },
];

export const mockElectionCountyCouncilMapWinners: ElectionMapWinners = [
  {
    id: 1,
    validVotes: 148783,
    winner: {
      name: "DUMITREL ION",
      partyColor: "#F8DD1B",
      votes: 82945,
    },
  },
  {
    id: 10886,
    validVotes: 108611,
    winner: {
      name: "PAVEL MARIAN",
      partyColor: "#FF0000",
      votes: 37068,
    },
  },
  {
    id: 11169,
    validVotes: 275640,
    winner: {
      name: "ALEXE COSTEL",
      partyColor: "#F8DD1B",
      votes: 104656,
    },
  },
  {
    id: 11830,
    validVotes: 185177,
    winner: {
      name: "THUMA HUBERT PETRU ŞTEFAN",
      partyColor: "#F8DD1B",
      votes: 89860,
    },
  },
  {
    id: 12053,
    validVotes: 184729,
    winner: {
      name: "BOGDAN IONEL-OVIDIU",
      partyColor: "#F8DD1B",
      votes: 64264,
    },
  },
  {
    id: 12539,
    validVotes: 120967,
    winner: {
      name: "GEORGESCU ALADIN-GIGI",
      partyColor: "#FF0000",
      votes: 54313,
    },
  },
  {
    id: 13227,
    validVotes: 221428,
    winner: {
      name: "PÉTER FERENC",
      partyColor: "#007300",
      votes: 85673,
    },
  },
  {
    id: 13933,
    validVotes: 186431,
    winner: {
      name: "ARSENE IONEL",
      shortName: "ALIANȚA PENTRU MODERNIZAREA NEAMȚULUI 2020",
      partyColor: "#808080",
      votes: 77208,
    },
  },
  {
    id: 14365,
    validVotes: 202234,
    winner: {
      name: "OPRESCU MARIUS",
      partyColor: "#FF0000",
      votes: 109957,
    },
  },
  {
    id: 14895,
    validVotes: 292875,
    winner: {
      name: "DUMITRESCU IULIAN",
      shortName: "ALIANȚA PNL USR PLUS",
      partyColor: "#808080",
      votes: 137286,
    },
  },
  {
    id: 15592,
    validVotes: 98590,
    winner: {
      name: "IANCU-SĂLĂJANU DINU",
      partyColor: "#F8DD1B",
      votes: 38464,
    },
  },
  {
    id: 16002,
    validVotes: 133862,
    winner: {
      name: "PATAKI CSABA",
      partyColor: "#007300",
      votes: 52371,
    },
  },
  {
    id: 16392,
    validVotes: 155172,
    winner: {
      name: "CÎMPEAN DANIELA",
      partyColor: "#F8DD1B",
      votes: 72757,
    },
  },
  {
    id: 17391,
    validVotes: 257169,
    winner: {
      name: "FLUTUR GHEORGHE",
      partyColor: "#F8DD1B",
      votes: 106960,
    },
  },
  {
    id: 18142,
    validVotes: 166754,
    winner: {
      name: "GÂDEA ADRIAN-IONUŢ",
      partyColor: "#FF0000",
      votes: 71584,
    },
  },
  {
    id: 18648,
    validVotes: 259660,
    winner: {
      name: "NICA ALIN-ADRIAN",
      partyColor: "#F8DD1B",
      votes: 104508,
    },
  },
  {
    id: 19284,
    validVotes: 86807,
    winner: {
      name: "TEODORESCU HORIA",
      partyColor: "#FF0000",
      votes: 33294,
    },
  },
  {
    id: 19520,
    validVotes: 158865,
    winner: {
      name: "RĂDULESCU CONSTANTIN",
      partyColor: "#FF0000",
      votes: 74129,
    },
  },
  {
    id: 10251,
    validVotes: 164488,
    winner: {
      name: "NISTOR LAURENŢIU",
      partyColor: "#FF0000",
      votes: 71052,
    },
  },
  {
    id: 9866,
    validVotes: 108176,
    winner: {
      name: "BORBOLY CSABA",
      partyColor: "#007300",
      votes: 69822,
    },
  },
  {
    id: 9449,
    validVotes: 151090,
    winner: {
      name: "POPESCU COSMIN-MIHAI",
      partyColor: "#FF0000",
      votes: 66109,
    },
  },
  {
    id: 9134,
    validVotes: 123521,
    winner: {
      name: "BEIANU DUMITRU",
      partyColor: "#F8DD1B",
      votes: 60255,
    },
  },
  {
    id: 589,
    validVotes: 163446,
    winner: {
      name: "CIONCA-ARGHIR IUSTIN-MARINEL",
      partyColor: "#F8DD1B",
      votes: 77318,
    },
  },
  {
    id: 1122,
    validVotes: 246587,
    winner: {
      name: "MÎNZÎNĂ ION",
      partyColor: "#FF0000",
      votes: 104269,
    },
  },
  {
    id: 1814,
    validVotes: 230731,
    winner: {
      name: "IVANCEA VALENTIN",
      partyColor: "#FF0000",
      votes: 94669,
    },
  },
  {
    id: 2513,
    validVotes: 254022,
    winner: {
      name: "BOLOJAN ILIE-GAVRIL",
      partyColor: "#F8DD1B",
      votes: 156241,
    },
  },
  {
    id: 3325,
    validVotes: 127608,
    winner: {
      name: "MOLDOVAN EMIL RADU",
      shortName: "ALIANȚA PENTRU BISTRIȚA-NĂSĂUD",
      partyColor: "#808080",
      votes: 66039,
    },
  },
  {
    id: 3747,
    validVotes: 153169,
    winner: {
      name: "FEDEROVICI DOINA-ELENA",
      partyColor: "#FF0000",
      votes: 65688,
    },
  },
  {
    id: 4231,
    validVotes: 109582,
    winner: {
      name: "CHIRIAC FRANCISK-IULIAN",
      partyColor: "#FF0000",
      votes: 55547,
    },
  },
  {
    id: 4481,
    validVotes: 206315,
    winner: {
      name: "VEŞTEA ADRIAN-IOAN",
      partyColor: "#F8DD1B",
      votes: 95615,
    },
  },
  {
    id: 20009,
    validVotes: 147886,
    winner: {
      name: "BUZATU DUMITRU",
      partyColor: "#FF0000",
      votes: 57283,
    },
  },
  {
    id: 12913,
    validVotes: 660118,
    winner: { name: "DAN NICUŞOR DANIEL", partyColor: "#808080", votes: 282631 },
  },
  {
    id: 5400,
    validVotes: 128072,
    winner: {
      name: "ILIUŢĂ VASILE",
      partyColor: "#FF0000",
      votes: 57100,
    },
  },
  {
    id: 5676,
    validVotes: 120336,
    winner: {
      name: "DUNCA ROMEO-DAN",
      partyColor: "#F8DD1B",
      votes: 51488,
    },
  },
  {
    id: 6150,
    validVotes: 252208,
    winner: {
      name: "TIŞE ALIN-PĂUNEL",
      partyColor: "#F8DD1B",
      votes: 127251,
    },
  },
  {
    id: 6793,
    validVotes: 272317,
    winner: {
      name: "LUPU MIHAI",
      partyColor: "#F8DD1B",
      votes: 101893,
    },
  },
  {
    id: 7308,
    validVotes: 68977,
    winner: {
      name: "TAMÁS SÁNDOR",
      partyColor: "#007300",
      votes: 43391,
    },
  },
  {
    id: 7588,
    validVotes: 216741,
    winner: {
      name: "ŞTEFAN CORNELIU",
      partyColor: "#FF0000",
      votes: 100064,
    },
  },
  {
    id: 8114,
    validVotes: 263874,
    winner: {
      name: "VASILE DORIN-COSMIN",
      shortName: "AEPD",
      partyColor: "#808080",
      votes: 111317,
    },
  },
  {
    id: 8747,
    validVotes: 198893,
    winner: {
      name: "FOTEA COSTEL",
      partyColor: "#FF0000",
      votes: 97109,
    },
  },
  {
    id: 4862,
    validVotes: 180641,
    winner: {
      name: "NEAGU PETRE-EMANOIL",
      shortName: "ALIANȚA PSD-PRO BUZĂU",
      partyColor: "#808080",
      votes: 100312,
    },
  },
  {
    id: 20574,
    validVotes: 144962,
    winner: {
      name: "TOMA CĂTĂLIN DUMITRU",
      shortName:
        "ALIANȚA PARTIDUL NAȚIONAL LIBERAL - UNIUNEA SALVAȚI ROMÂNIA - PARTIDUL LIBERTATE, UNITATE ȘI SOLIDARITATE (PNL-USR-PLUS)",
      partyColor: "#808080",
      votes: 65637,
    },
  },
];

export const mockMayorElectionWinners = [
  {
    id: 2,
    validVotes: 1013,
    winner: {
      name: "TODEA PETRU-TIBERIU",
      partyColor: "#F8DD1B",
      votes: 796,
    },
  },
  {
    id: 451,
    validVotes: 672,
    winner: {
      name: "BULGĂR IONEL",
      partyColor: "#F8DD1B",
      votes: 417,
    },
  },
  {
    id: 447,
    validVotes: 504,
    winner: {
      name: "PETRUŢ BUJOR",
      partyColor: "#F8DD1B",
      votes: 366,
    },
  },
  {
    id: 445,
    validVotes: 642,
    winner: {
      name: "TOADER BENIAMIN",
      partyColor: "#F8DD1B",
      votes: 366,
    },
  },
  {
    id: 438,
    validVotes: 1687,
    winner: {
      name: "PETRUSE MARIN-IOAN",
      partyColor: "#F8DD1B",
      votes: 1006,
    },
  },
  {
    id: 425,
    validVotes: 3557,
    winner: {
      name: "PONORAN SILVIU",
      partyColor: "#F8DD1B",
      votes: 2054,
    },
  },
  {
    id: 416,
    validVotes: 2921,
    winner: {
      name: "HĂLĂLAI MIREL-VASILE",
      partyColor: "#FF0000",
      votes: 1654,
    },
  },
  {
    id: 403,
    validVotes: 4210,
    winner: {
      name: "VINŢELER SILVIU",
      partyColor: "#F8DD1B",
      votes: 3305,
    },
  },
  {
    id: 379,
    validVotes: 8207,
    winner: {
      name: "TEBAN ADRIAN OVIDIU",
      partyColor: "#F8DD1B",
      votes: 4128,
    },
  },
  {
    id: 368,
    validVotes: 4171,
    winner: {
      name: "PAŞCA CRISTIAN-DAN",
      partyColor: "#F8DD1B",
      votes: 2103,
    },
  },
  {
    id: 359,
    validVotes: 1814,
    winner: {
      name: "PANDOR TRAIAN",
      partyColor: "#F8DD1B",
      votes: 676,
    },
  },
  {
    id: 353,
    validVotes: 2283,
    winner: {
      name: "ALBU CRISTIAN ALEXANDRU",
      partyColor: "#F8DD1B",
      votes: 952,
    },
  },
  {
    id: 348,
    validVotes: 454,
    winner: {
      name: "MIHĂLŢAN ADRIAN-NICOLAE",
      partyColor: "#F8DD1B",
      votes: 231,
    },
  },
  {
    id: 342,
    validVotes: 406,
    winner: {
      name: "JUCAN ALIN-ALEXANDRU",
      partyColor: "#F8DD1B",
      votes: 348,
    },
  },
  {
    id: 337,
    validVotes: 749,
    winner: {
      name: "ZILAHI FLORIN-CLAUDIU",
      partyColor: "#F8DD1B",
      votes: 499,
    },
  },
  {
    id: 315,
    validVotes: 10476,
    winner: {
      name: "NISTOR DORIN GHEORGHE",
      partyColor: "#F8DD1B",
      votes: 6476,
    },
  },
  {
    id: 458,
    validVotes: 742,
    winner: {
      name: "NICULA ALIN-TEODOR",
      partyColor: "#F8DD1B",
      votes: 670,
    },
  },
  {
    id: 463,
    validVotes: 345,
    winner: {
      name: "RAICA VASILE",
      partyColor: "#FF0000",
      votes: 285,
    },
  },
  {
    id: 472,
    validVotes: 772,
    winner: {
      name: "CRISTEA IOAN",
      partyColor: "#FF0000",
      votes: 395,
    },
  },
  {
    id: 477,
    validVotes: 1585,
    winner: {
      name: "FURDUI EUGEN",
      partyColor: "#F8DD1B",
      votes: 563,
    },
  },
  {
    id: 575,
    validVotes: 977,
    winner: {
      name: "PETRICELE DORU",
      partyColor: "#FF0000",
      votes: 529,
    },
  },
  {
    id: 567,
    validVotes: 1685,
    winner: {
      name: "ALDEA DAN-FLORIN",
      partyColor: "#660066",
      votes: 970,
    },
  },
  {
    id: 564,
    validVotes: 948,
    winner: {
      name: "LAZEA NICOLAE",
      partyColor: "#F8DD1B",
      votes: 499,
    },
  },
  {
    id: 554,
    validVotes: 1955,
    winner: {
      name: "ALBA GHEORGHE",
      partyColor: "#F8DD1B",
      votes: 1102,
    },
  },
  {
    id: 549,
    validVotes: 1340,
    winner: {
      name: "JINAR CONSTANTIN",
      partyColor: "#F8DD1B",
      votes: 1111,
    },
  },
  {
    id: 544,
    validVotes: 1350,
    winner: {
      name: "POPA TRAIAN ŞTEFAN",
      partyColor: "#FF0000",
      votes: 754,
    },
  },
  {
    id: 538,
    validVotes: 1482,
    winner: {
      name: "STĂNILĂ IULIA",
      partyColor: "#F8DD1B",
      votes: 752,
    },
  },
  {
    id: 296,
    validVotes: 6991,
    winner: {
      name: "ROTAR GHEORGHE-VALENTIN",
      partyColor: "#F8DD1B",
      votes: 5516,
    },
  },
  {
    id: 531,
    validVotes: 1816,
    winner: {
      name: "MĂRGINEAN TEODOR-FLORIN",
      partyColor: "#F8DD1B",
      votes: 1232,
    },
  },
  {
    id: 520,
    validVotes: 1273,
    winner: {
      name: "OANĂ MARINELA",
      partyColor: "#F8DD1B",
      votes: 429,
    },
  },
  {
    id: 511,
    validVotes: 953,
    winner: {
      name: "COSTEA CRISTIAN-VASILE",
      partyColor: "#F8DD1B",
      votes: 493,
    },
  },
  {
    id: 503,
    validVotes: 2702,
    winner: {
      name: "MORAR NICOLAE-FLORIN",
      partyColor: "#F8DD1B",
      votes: 1033,
    },
  },
  {
    id: 498,
    validVotes: 1427,
    winner: {
      name: "POPA IOAN-IANCU",
      partyColor: "#F8DD1B",
      votes: 833,
    },
  },
  {
    id: 493,
    validVotes: 1201,
    winner: {
      name: "FRĂŢILĂ ILIE",
      partyColor: "#F8DD1B",
      votes: 675,
    },
  },
  {
    id: 487,
    validVotes: 1410,
    winner: {
      name: "STĂNILĂ AUREL-EMIL",
      partyColor: "#F8DD1B",
      votes: 604,
    },
  },
  {
    id: 483,
    validVotes: 790,
    winner: {
      name: "LOMBREA VASILE",
      partyColor: "#F8DD1B",
      votes: 403,
    },
  },
  {
    id: 526,
    validVotes: 849,
    winner: {
      name: "CORCHEŞ SORIN-CONSTANTIN",
      partyColor: "#F8DD1B",
      votes: 569,
    },
  },
  {
    id: 246,
    validVotes: 22024,
    winner: {
      name: "PLEŞA GABRIEL-CODRU",
      partyColor: "#01A0E4",
      votes: 8107,
    },
  },
  {
    id: 220,
    validVotes: 8123,
    winner: {
      name: "BADEA IULIA-ADRIANA-OANA",
      partyColor: "#F8DD1B",
      votes: 3729,
    },
  },
  {
    id: 215,
    validVotes: 467,
    winner: {
      name: "MACAVEI MIRCEA-LIVIU",
      partyColor: "#F8DD1B",
      votes: 209,
    },
  },
  {
    id: 87,
    validVotes: 1057,
    winner: {
      name: "BUBUR LENUŢA",
      partyColor: "#F8DD1B",
      votes: 608,
    },
  },
  {
    id: 83,
    validVotes: 704,
    winner: {
      name: "TUHUŢ RADU-MARCEL",
      partyColor: "#FF0000",
      votes: 619,
    },
  },
  { id: 75, validVotes: 1733, winner: { name: "DĂMIAN GHEORGHE", partyColor: "#808080", votes: 1527 } },
  {
    id: 68,
    validVotes: 1156,
    winner: {
      name: "COMANDARU CONSTANTIN",
      partyColor: "#F8DD1B",
      votes: 844,
    },
  },
  {
    id: 65,
    validVotes: 240,
    winner: {
      name: "TRIF IOAN",
      partyColor: "#000099",
      votes: 163,
    },
  },
  {
    id: 60,
    validVotes: 910,
    winner: {
      name: "ALDEA LENUŢA",
      partyColor: "#F8DD1B",
      votes: 596,
    },
  },
  {
    id: 57,
    validVotes: 438,
    winner: {
      name: "NEAMŢU ILIE",
      partyColor: "#F8DD1B",
      votes: 413,
    },
  },
  {
    id: 91,
    validVotes: 1211,
    winner: {
      name: "TODERICIU AUREL-FLORIN",
      partyColor: "#B2B200",
      votes: 650,
    },
  },
  { id: 53, validVotes: 1048, winner: { name: "BODEA LUCIAN-TIBERIU", partyColor: "#808080", votes: 499 } },
  {
    id: 43,
    validVotes: 1117,
    winner: {
      name: "ALDEA IOAN",
      partyColor: "#F8DD1B",
      votes: 619,
    },
  },
  {
    id: 38,
    validVotes: 642,
    winner: {
      name: "GHERMAN NICOLAE",
      partyColor: "#F8DD1B",
      votes: 412,
    },
  },
  {
    id: 31,
    validVotes: 2040,
    winner: {
      name: "GLIGOR TRAIAN",
      partyColor: "#F8DD1B",
      votes: 1609,
    },
  },
  {
    id: 25,
    validVotes: 679,
    winner: {
      name: "BICA VASILE",
      partyColor: "#F8DD1B",
      votes: 523,
    },
  },
  {
    id: 21,
    validVotes: 857,
    winner: {
      name: "HELER SANDU",
      partyColor: "#F8DD1B",
      votes: 675,
    },
  },
  {
    id: 16,
    validVotes: 1253,
    winner: {
      name: "PANTEA GHEORGHE",
      partyColor: "#F8DD1B",
      votes: 657,
    },
  },
  {
    id: 9,
    validVotes: 820,
    winner: {
      name: "ZAHARIE ARON",
      partyColor: "#F8DD1B",
      votes: 325,
    },
  },
  {
    id: 47,
    validVotes: 763,
    winner: {
      name: "NAPĂU CORNEL",
      partyColor: "#FF0000",
      votes: 560,
    },
  },
  {
    id: 580,
    validVotes: 2550,
    winner: {
      name: "BARBU PETRU-IOAN",
      partyColor: "#F8DD1B",
      votes: 960,
    },
  },
  {
    id: 96,
    validVotes: 724,
    winner: {
      name: "BÂSCĂ SORIN-GHEORGHE",
      partyColor: "#F8DD1B",
      votes: 422,
    },
  },
  {
    id: 103,
    validVotes: 541,
    winner: {
      name: "CÎNDEA EMILIA-LIVIA",
      partyColor: "#F8DD1B",
      votes: 430,
    },
  },
  {
    id: 208,
    validVotes: 911,
    winner: {
      name: "ALEXANDRU LIVIU-GIGEL",
      partyColor: "#F8DD1B",
      votes: 457,
    },
  },
  {
    id: 202,
    validVotes: 1909,
    winner: {
      name: "BREAZ FLAVIUS",
      partyColor: "#F8DD1B",
      votes: 1188,
    },
  },
  {
    id: 194,
    validVotes: 1560,
    winner: {
      name: "OPRUŢA DAN-COSMIN",
      partyColor: "#F8DD1B",
      votes: 776,
    },
  },
  {
    id: 188,
    validVotes: 1725,
    winner: {
      name: "PENCIU IOAN-RADU",
      partyColor: "#01A0E4",
      votes: 825,
    },
  },
  {
    id: 183,
    validVotes: 1308,
    winner: {
      name: "CSEGEZI EDIT-SUSANA",
      partyColor: "#007300",
      votes: 569,
    },
  },
  {
    id: 175,
    validVotes: 1714,
    winner: {
      name: "INDREIU MARIAN-CĂTĂLIN",
      partyColor: "#F8DD1B",
      votes: 1013,
    },
  },
  {
    id: 169,
    validVotes: 813,
    winner: {
      name: "HAN HORAŢIU-NICOLAE",
      partyColor: "#F8DD1B",
      votes: 599,
    },
  },
  {
    id: 99,
    validVotes: 1461,
    winner: {
      name: "HĂPRIAN VISARION",
      partyColor: "#F8DD1B",
      votes: 1244,
    },
  },
  {
    id: 162,
    validVotes: 2357,
    winner: {
      name: "TRIF ALIN",
      partyColor: "#F8DD1B",
      votes: 2123,
    },
  },
  {
    id: 148,
    validVotes: 3050,
    winner: {
      name: "RUSU TRAIAN",
      partyColor: "#F8DD1B",
      votes: 1581,
    },
  },
  {
    id: 140,
    validVotes: 1174,
    winner: {
      name: "NICOLA MARIN",
      partyColor: "#F8DD1B",
      votes: 824,
    },
  },
  {
    id: 133,
    validVotes: 527,
    winner: {
      name: "POPA AUGUSTIN",
      partyColor: "#F8DD1B",
      votes: 455,
    },
  },
  {
    id: 128,
    validVotes: 884,
    winner: {
      name: "VÎRCIU MARIN",
      partyColor: "#F8DD1B",
      votes: 427,
    },
  },
  {
    id: 123,
    validVotes: 1041,
    winner: {
      name: "MUNTEAN IOAN",
      partyColor: "#FF0000",
      votes: 526,
    },
  },
  {
    id: 114,
    validVotes: 2048,
    winner: {
      name: "RAICA ROMULUS",
      partyColor: "#F8DD1B",
      votes: 765,
    },
  },
  {
    id: 107,
    validVotes: 872,
    winner: {
      name: "STOIA IOAN",
      partyColor: "#F8DD1B",
      votes: 720,
    },
  },
  { id: 156, validVotes: 391, winner: { name: "MOGA VICTORIA", partyColor: "#808080", votes: 219 } },
  {
    id: 108885,
    validVotes: 544,
    winner: {
      name: "DEÁK-SZÉKELY SZILÁRD-LEVENTE",
      partyColor: "#007300",
      votes: 326,
    },
  },
];

export const mockCandidatesList: ElectionResultsPartyCandidates[] = [
  {
    name: "PARTIDUL PUTERII UMANISTE (SOCIAL-LIBERAL)",
    candidates: [
      { name: "AURELIA-ANA ARIEŞAN" },
      { name: "MIHAI FLUERAŞ" },
      { name: "LEONTIN ŢIBACOV" },
      { name: "SPIRIDON GORONEA" },
      { name: "MĂDĂLIN CIOARA" },
      { name: "IOAN CRISTEA" },
      { name: "IOAN MACARIE-ANCĂU" },
    ],
  },
  {
    name: "ALIANȚA PENTRU UNIREA ROMÂNILOR",
    candidates: [
      { name: "DANIEL-GHEORGHE RUSU" },
      { name: "IULIAN-REMUS BLAJ" },
      { name: "LUMINIŢA-ANA OPRUŢA" },
      { name: "MIRELA-ELENA FECHETE" },
      { name: "DANIELA-MIHAELA PINTEA" },
      { name: "MARIN JURCA" },
      { name: "RUXANDRA-MIHAELA MIHAI" },
    ],
  },
  {
    name: "UNIUNEA DEMOCRATĂ MAGHIARĂ DIN ROMÂNIA",
    candidates: [
      { name: "ÁRPÁD-CSABA LADÁNYI" },
      { name: "ZSOLT-AŔPÁD BONA" },
      { name: "ATTILA-ISTVÁN HARI" },
      { name: "SZILÁRD-LEVENTE DEÁK-SZÉKELY" },
      { name: "EDIT-SUSANA CSEGEZI" },
      { name: "ATTILA-GIULA FARKAŞ" },
      { name: "ARTÚR-EDVIN CSONGVAI" },
    ],
  },
  {
    name: "PARTIDUL VERDE",
    candidates: [
      { name: "NICOLAIE MATEI" },
      { name: "CLAUDIU-IOAN DĂRĂMUŞ" },
      { name: "BOGDAN-GABRIEL SANDU" },
      { name: "DUMITRU DICU" },
      { name: "NATALIA RONCEA" },
      { name: "ELENA-GABRIELA RAHOVEAN" },
      { name: "PETRUŢA OPRIŢA" },
    ],
  },
  {
    name: "PARTIDUL ROMÂNIA MARE",
    candidates: [
      { name: "GHEORGHE ŞTEFAN JORJ" },
      { name: "MARINELA-SANDA ANDREŞEL" },
      { name: "AMALIA-ADELA BĂL" },
      { name: "MARIAN-MIREL SÎRB" },
      { name: "IONEL-OVIDIU BUCUR" },
      { name: "DANIEL-MIHĂILĂ CURŞEU" },
      { name: "MELINDA DACZO" },
    ],
  },
  { name: "ALIANȚA RENAȘTEREA NAȚIONALĂ", candidates: [{ name: "GHEORGHE COLCER" }] },
  {
    name: "PARTIDUL ECOLOGIST ROMÂN",
    candidates: [
      { name: "CRISTIAN BOBEŞI" },
      { name: "GERHARTH-IONIŢĂ ILIEŞIU" },
      { name: "CONSTANTIN MARICA" },
      { name: "VALENTIN RĂDAC" },
      { name: "IULIAN-OVIDIU OLTEAN" },
      { name: "OVIDIU FELEA" },
      { name: "ROXANA-MARIA NELEGA" },
    ],
  },
  {
    name: "PARTIDUL MIȘCAREA POPULARĂ",
    candidates: [
      { name: "CLEMENT NEGRUŢ" },
      { name: "GHEORGHE-ALEXANDRU NICOARĂ" },
      { name: "FILOFTEIA BARSTAN" },
      { name: "VASILE GÎNŢA" },
      { name: "LIVIU RAREŞ DAMIAN" },
      { name: "LUCIA-COSMINA SCURTU" },
      { name: "LAURENŢIU-MARIAN BESOI" },
    ],
  },
  {
    name: "ALIANȚA USR PLUS",
    candidates: [
      { name: "BENIAMIN TODOSIU" },
      { name: "MIHAIL DAVID" },
      { name: "GHEORGHE-CLAUDIU NEMEŞ" },
      { name: "IOANA PĂCURAR" },
      { name: "PAVEL-CĂTĂLIN COMAN" },
      { name: "DOINA RADU" },
      { name: "PAUL-SIMION POPA" },
    ],
  },
  {
    name: "PARTIDUL NAȚIONAL LIBERAL",
    candidates: [
      { name: "FLORIN-CLAUDIU ROMAN" },
      { name: "CORNELIU OLAR" },
      { name: "ION-ALIN-DAN IGNAT" },
      { name: "ADRIAN BOGDAN" },
      { name: "FLORIN ARION" },
      { name: "TEODORA-CODRUŢA MUREŞAN" },
      { name: "IOAN-DAN BRĂTEAN" },
    ],
  },
  {
    name: "PARTIDUL PRO ROMÂNIA",
    candidates: [
      { name: "IOAN LAZĂR" },
      { name: "GABRIEL-TOMA-OCTAVIAN AL.TOMI" },
      { name: "NICOLAE-SIMION BESOIU" },
      { name: "IONEL-DANIEL TARCĂU" },
      { name: "ELENA-DANIELA CSORTÁN " },
      { name: "EMILIA PETRUŢ" },
      { name: "ILIE-AURELIAN FOLEA" },
    ],
  },
  {
    name: "PARTIDUL SOCIAL DEMOCRAT",
    candidates: [
      { name: "RADU-MARCEL TUHUŢ" },
      { name: "IOAN DÎRZU" },
      { name: "EUGENIA-MARCELA DĂRĂMUŞ" },
      { name: "BOGDAN MEDREA" },
      { name: "NICOLAE LUCA" },
      { name: "MARCEL OŢOIU" },
      { name: "CĂLIN RADU" },
    ],
  },
  {
    name: "UNIUNEA DEMOCRATICĂ A SLOVACILOR ȘI CEHILOR DIN ROMÂNIA",
    candidates: [
      { name: "ADRIAN-MIROSLAV MERKA" },
      { name: "DUŞAN SOMRAK" },
      { name: "RUJENCA BOVDIŞ" },
      { name: "ŞTEFAN BOUDA" },
    ],
  },
  {
    name: "COMUNITATEA RUȘILOR LIPOVENI DIN ROMÂNIA",
    candidates: [
      { name: "SILVIU FEODOR" },
      { name: "ANDRIAN AMPLEEV" },
      { name: "NECULAI FEODOT" },
      { name: "SVETLANA-FLORENTINA CRĂCIUN" },
    ],
  },
  {
    name: "UNIUNEA CULTURALĂ A RUTENILOR DIN ROMÂNIA",
    candidates: [
      { name: "IULIUS MARIAN FIRCZAK" },
      { name: "FRANCISC OSCAR GAL" },
      { name: "MARIANA-SVETLANA MUREŞAN" },
      { name: "VIORICA BOJCSUK" },
      { name: "GABRIELA-CRISTINA BODNARIUC" },
      { name: "MARIA BOCICOR" },
    ],
  },
  { name: "ASOCIAȚIA ITALIENILOR DIN ROMÂNIA – RO.AS.IT.", candidates: [{ name: "ANDI-GABRIEL GROSARU" }] },
  { name: "FEDERAȚIA COMUNITĂȚILOR EVREIEȘTI DIN ROMÂNIA", candidates: [{ name: "SILVIU VEXLER" }] },
  { name: "UNIUNEA DEMOCRATĂ TURCĂ DIN ROMÂNIA", candidates: [{ name: "IUSEIN IBRAM" }] },
  {
    name: "UNIUNEA SÂRBILOR DIN ROMÂNIA",
    candidates: [
      { name: "OGNEAN CRÎSTICI" },
      { name: "ZLATIBORCA MARCOV" },
      { name: "BORISLAV VELIMIROVICI" },
      { name: "RADMILA-GEORGIANA DRAGOTOIU" },
      { name: "BORCO-SREDA IORGOVAN" },
    ],
  },
  {
    name: "UNIUNEA UCRAINENILOR DIN ROMÂNIA",
    candidates: [
      { name: "NICOLAE-MIROSLAV PETREŢCHI" },
      { name: "IRINA-LIUBA HORVAT" },
      { name: "ILIE SAUCIUC" },
      { name: "BOGDAN MOISEI" },
      { name: "ANNA SAMBOR" },
      { name: "IVAN LIBER" },
    ],
  },
  {
    name: "UNIUNEA ARMENILOR DIN ROMÂNIA",
    candidates: [
      { name: "VARUJAN PAMBUCCIAN" },
      { name: "SIRUN TERZIAN" },
      { name: "EMANUEL NAZARETIAN" },
      { name: "CRISTIAN-LAURENŢIU LAZAROVICI" },
      { name: "CARLOTA-SIMONA TURCULEŢ-CALUSTIAN" },
      { name: "PAUL-MARIAN ANCA" },
    ],
  },
  {
    name: "FORUMUL DEMOCRAT AL GERMANILOR DIN ROMÂNIA",
    candidates: [{ name: "OVIDIU-VICTOR GANŢ" }, { name: "THOMAS ŞINDILARIU" }, { name: "CHRISTINE MANTA-KLEMENS" }],
  },
  {
    name: "ASOCIAȚIA MACEDONENILOR DIN ROMÂNIA",
    candidates: [{ name: "IONEL STANCU" }, { name: "CRISTINA CODREANU" }],
  },
  { name: "ASOCIAȚIA LIGA ALBANEZILOR DIN ROMÂNIA", candidates: [{ name: "BOGDAN-ALIN STOICA" }] },
  {
    name: "UNIUNEA BULGARĂ DIN BANAT-ROMÂNIA",
    candidates: [
      { name: "GHEORGHE NACOV" },
      { name: "PETRU TOPCIOV" },
      { name: "ADRIAN-SORIN COSILCOV" },
      { name: "ANA-SILVIA DEMIAN" },
      { name: "DANIEL-MARIUS PIŢ" },
    ],
  },
  {
    name: "UNIUNEA POLONEZILOR DIN ROMÂNIA",
    candidates: [
      { name: "GHERVAZEN LONGHER" },
      { name: "VICTORIA LONGHER" },
      { name: "IOSEF IRIŞEC" },
      { name: "ANA ZIELONKA" },
    ],
  },
  { name: "UNIUNEA ELENĂ DIN ROMÂNIA", candidates: [{ name: "DRAGOŞ-GABRIEL ZISOPOL" }] },
  {
    name: "ASOCIAȚIA PARTIDA ROMILOR “PRO-EUROPA”",
    candidates: [
      { name: "CĂTĂLIN-ZAMFIR MANEA" },
      { name: "IONUŢ-CONSTANTIN PĂUN" },
      { name: "BOGDAN-IONUŢ ANDRONE" },
      { name: "AURELIAN-DRAGOŞ ROŞIANU" },
      { name: "ADRIAN-COSTIN BERBEC" },
      { name: "MIRELA CURT" },
    ],
  },
  { name: "UNIUNEA CROAȚILOR DIN ROMÂNIA", candidates: [{ name: "GIURECI-SLOBODAN GHERA" }] },
];

// To fake loading times
const delay = (timeout: number) => new Promise((resolve) => setTimeout(resolve, timeout));

export const mockElectionAPI = makeElectionApi({
  fetch: mockFetch([
    [
      "GET",
      "/ballot",
      (async ({ query: { BallotId, Division, CountyId, LocalityId } }) => {
        await delay(1000);
        const scope = {
          type: Division,
          countyId: CountyId,
          localityId: Division !== "diaspora_country" ? LocalityId : undefined,
          countryId: Division === "diaspora_country" ? LocalityId : undefined,
          countyName: "Prahova",
          localityName: "Ploiești",
          countryName: "Spania",
        };
        return {
          id: BallotId,
          scope,
          meta: mockPresidentialElectionMeta,
          turnout: mockPresidentialElectionTurnout,
          observation: mockObservation,
          results: mockResults,
        };
      }) as APIMockHandler<ElectionBallot, unknown, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
    ],

    [
      "GET",
      "/ballots",
      (async () => {
        await delay(1000);
        return mockElectionList;
      }) as APIMockHandler<ElectionBallotMeta[]>,
    ],

    [
      "GET",
      "/ballots/1/candidates",
      (async () => {
        await delay(1000);
        return mockCandidatesList;
      }) as APIMockHandler<ElectionResultsPartyCandidates[]>,
    ],

    [
      "GET",
      "/counties",
      (async () => {
        await delay(1000);
        return [
          { id: 0, name: "Prahova" },
          { id: 1, name: "Buzău" },
          { id: 2, name: "Brașov" },
          { id: 3, name: "Constanța" },
        ];
      }) as APIMockHandler<{ id: number; name: string }[]>,
    ],

    [
      "GET",
      "/localities",
      (async () => {
        await delay(1000);
        return [
          { id: 0, name: "Văleni de Munte" },
          { id: 1, name: "Ploiești" },
          { id: 2, name: "Slănic" },
          { id: 3, name: "Câmpina" },
        ];
      }) as APIMockHandler<{ id: number; name: string }[]>,
    ],

    [
      "GET",
      "/countries",
      (async () => {
        await delay(1000);
        return [
          { id: 1, name: "Portugalia" },
          { id: 2, name: "Spania" },
          { id: 3, name: "Regatul Unit al Marii Britanii și Irlandei de Nord" },
        ];
      }) as APIMockHandler<{ id: number; name: string }[]>,
    ],

    [
      "GET",
      "/winners/counties",
      (async () => mockElectionCountyCouncilMapWinners) as APIMockHandler<ElectionMapWinners>,
    ],
    ["GET", "/winners/countries", (async () => mockElectionMapWinners) as APIMockHandler<ElectionMapWinners>],
    ["GET", "/winners/localities", (async () => mockMayorElectionWinners) as APIMockHandler<ElectionMapWinners>],
  ]),
});
